// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-3869838d]{color:#767676;display:flex;flex-direction:row;flex-shrink:0;font-size:.75rem;gap:.5rem}a[data-v-3869838d]:focus,a[data-v-3869838d]:hover{color:#4876bb}a div[data-v-3869838d]{display:flex;flex:nowrap;flex-direction:column}@media screen and (min-width:512px){a[data-v-3869838d]{gap:1rem}a div[data-v-3869838d]{width:20em}a div span[data-v-3869838d]:first-child{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
